import { render, staticRenderFns } from "./SupportForm.vue?vue&type=template&id=21b605e0&scoped=true&"
import script from "./SupportForm.vue?vue&type=script&lang=ts&"
export * from "./SupportForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b605e0",
  null
  
)

export default component.exports